import { Box, Paper, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";

import AdminDashboardLayout from "./AdminDashboardLayout";
import CounsellorsPage from "./Counsellors/CounsellorsPage";
import SchoolsPage from "./Schools/SchoolsPage";
import SkillProvidersPage from "./SkillProviders/SkillProvidersPage";
import StudentsPage from "./StudentsPage";
import FranchisesPage from "./Franchises/FranchisesPage";

const SECTION_LABELS = {
  counsellors: "Counsellors",
  "skill-providers": "Skill Providers",
  schools: "Schools",
  franchises: "Franchise",
};

const ComingSoonSection = ({ title }) => (
  <AdminDashboardLayout>
    <Box>
      <Typography sx={{ fontSize: 21, fontWeight: 700, color: "#171725", mb: 1.4 }}>
        {title}
      </Typography>

      <Paper
        elevation={0}
        sx={{
          borderRadius: "8px",
          bgcolor: "#fff",
          border: "1px solid #EFEFF4",
          p: 3,
        }}
      >
        <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#171725" }}>
          {title} module
        </Typography>
        <Typography sx={{ fontSize: 14, color: "#667085", mt: 1 }}>
          This section is under maintenance.
        </Typography>
      </Paper>
    </Box>
  </AdminDashboardLayout>
);

ComingSoonSection.propTypes = {
  title: PropTypes.string.isRequired,
};

const AdminDashboardPage = () => {
  const { section = "students" } = useParams();

  if (section === "students") {
    return <StudentsPage />;
  }

  if (section === "counsellors") {
    return <CounsellorsPage />;
  }

  if (section === "skill-providers") {
    return <SkillProvidersPage />;
  }

  if (section === "schools") {
    return <SchoolsPage />;
  }

  if (section === "franchises") {
    return <FranchisesPage />;
  }

  return <ComingSoonSection title={SECTION_LABELS[section] || "Admin Dashboard"} />;
};

export default AdminDashboardPage;
